import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BetslipOverAskPickSelectorBaseComponent } from '../../betslip-over-ask-pick-selector-base.component';

@Component({
    selector: 'bs-digital-over-ask-pick-selector',
    templateUrl: './betslip-over-ask-pick-selector.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BetslipOverAskPickSelectorComponent extends BetslipOverAskPickSelectorBaseComponent {}
